export default __webpack_public_path__ + "static/logo-77dbd6c550874fb3b57457e0158f1dc3.svg";